// src/r/index.ts
var r = (data) => {
  const { tag, attributes, children, style, onClick } = data;
  if (attributes && attributes["style"]) {
    throw "Use style property to define element styles";
  }
  const el = document.createElement(tag);
  if (attributes) {
    const attributesData = Object.entries(attributes);
    attributesData.forEach((attribute) => {
      el.setAttribute(attribute[0], attribute[1]);
    });
  }
  if (style) {
    const styles = Object.entries(style);
    styles.forEach(([prop, value]) => {
      el.style[prop] = value;
    });
  }
  if (children && Array.isArray(children)) {
    children.forEach((child) => {
      el.appendChild(child);
    });
  } else if (typeof children == "string" && /(<\w*)((\s\/>)|(.*<\/\w*>))/gm.test(children)) {
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = children;
    Array.from(tempDiv.children).forEach((tempDivChild) => {
      el.appendChild(tempDivChild);
    });
  } else if (typeof children == "string") {
    el.innerHTML = children;
  }
  if (onClick) {
    el.onclick = onClick;
  }
  return el;
};
var r_default = r;

// src/index.ts
if (typeof window !== "undefined") {
  window.r = r_default;
}
export {
  r_default as r
};
